module.exports = __webpack_public_path__ + "064f461bf266664f037265c7a4c07c71.png";


//////////////////
// WEBPACK FOOTER
// ./app/pages/HomePage2/Features/whitelabel.png
// module id = 859
// module chunks = 1